import CryptoJS from "crypto-js";

const storeCredentials = function (vueInstance, payload) {
  const duration = "1d";
  vueInstance.$cookies.set("username", payload.username, duration);

  const cipherPass = CryptoJS.AES.encrypt(payload.password, "Marepoto-Tusunami").toString();
  vueInstance.$cookies.set("password", cipherPass, duration);
};

export default storeCredentials;
